import { companyDocumentIdentity } from '../../../../shared/documents';
import PageNumber from './PageNumber';
import { formatDocumentDate } from '../utils/documentFormatters';

export default function DocumentFooter({ documentType, generatedAt, version, pageNumber, totalPages, confidentiality }) {
  return <footer className="document-footer"><span>{companyDocumentIdentity.shortName} · {companyDocumentIdentity.descriptor}</span><span>{confidentiality || 'Document interne'} · Version {version || 1}{generatedAt ? ` · ${formatDocumentDate(generatedAt)}` : ''}</span><PageNumber pageNumber={pageNumber} totalPages={totalPages} /></footer>;
}
